(() => {
  const CARD_SELECTOR = '.featured-products-card';
  const VIDEO_CONTAINER_SELECTOR = '[data-featured-card-video]';

  const tryPlay = (video) => {
    if (!video) return;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        // Ignore autoplay restrictions; playback will retry on next interaction.
      });
    }
  };

  const pauseAndReset = (video) => {
    if (!video) return;
    video.pause();
    try {
      video.currentTime = 0;
    } catch (error) {
      // Some browsers can reject currentTime changes for not-yet-loaded media.
    }
  };

  const initCardVideo = (card) => {
    if (!card || card.dataset.videoHoverInit === 'true') return;

    const videoContainer = card.querySelector(VIDEO_CONTAINER_SELECTOR);
    if (!videoContainer) return;

    const video = videoContainer.querySelector('video');
    if (!video) return;

    card.dataset.videoHoverInit = 'true';

    card.addEventListener('mouseenter', () => tryPlay(video));
    card.addEventListener('mouseleave', () => pauseAndReset(video));

    card.addEventListener('focusin', () => tryPlay(video));
    card.addEventListener('focusout', (event) => {
      if (!card.contains(event.relatedTarget)) {
        pauseAndReset(video);
      }
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pauseAndReset(video);
    });
  };

  const initAll = () => {
    document.querySelectorAll(CARD_SELECTOR).forEach(initCardVideo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
